// extracted by mini-css-extract-plugin
export default {"price":"j2-z","onSale":"k2-z","msrpLabelPrice":"l2-z","originalPrice":"m2-z","msrpLabel":"n2-z","percentOff":"o2-z"};